// extracted by mini-css-extract-plugin
export default {"menuIcon":"MenuButton__menuIcon--cJWX7","menuIcon_active":"MenuButton__menuIcon_active--l3aqZ"};